/* Farmer's Body accessibility fixes, Oct 2026.
   Additive only: adds names, roles and keyboard support to existing controls.
   It does not change what any button, form or app does.
   Remove this file and its tag in layout/theme.liquid to undo. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  function text(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function once(el, key) {
    if (el.getAttribute('data-fb-' + key)) return false;
    el.setAttribute('data-fb-' + key, '1');
    return true;
  }

  /* 1. Custom label order grid (bulk order app): name every flavor quantity box
        and its + / - controls. Typing a number in the box is the keyboard path;
        the + / - stay out of the Tab order so 87 flavors don't become 261 stops. */
  function fixBulkGrid(root) {
    root.querySelectorAll('.multivariants_block_last_holder').forEach(function (row) {
      var input = row.querySelector('input.multivariants_block_qty_input');
      if (!input || !once(row, 'grid')) return;
      var name = text(row.querySelector('.multivariants_block_label')) || 'Flavor';
      input.setAttribute('aria-label', name + ' quantity');
      // In the app's markup the "left" box adds and the "right" box subtracts.
      [['.multivariants_block_qty_box_left', 'Increase'], ['.multivariants_block_qty_box_right', 'Decrease']].forEach(function (pair) {
        var el = row.querySelector(pair[0]);
        if (!el) return;
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-label', pair[1] + ' ' + name + ' quantity');
        var svg = el.querySelector('svg');
        if (svg) { svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false'); }
      });
    });
  }

  /* 2. Product options (Type, Flavor, Scent). The theme shows each option as a
        button that opens a list of choices built from plain divs, which a
        keyboard could not reach. Make the list a listbox: Tab or Enter on the
        button moves focus to the current choice, arrows move between choices,
        Enter or Space picks one and returns focus to the button, Escape closes.
        Inline (non-dropdown) swatches become a radio group. */
  function syncOptions(list, role) {
    var items = [].slice.call(list.querySelectorAll('[data-swatch-item]'));
    var selected = items.filter(function (i) { return i.classList.contains('is--selected'); })[0] || items[0];
    items.forEach(function (i) {
      var on = i.classList.contains('is--selected');
      i.setAttribute('role', role);
      i.setAttribute(role === 'option' ? 'aria-selected' : 'aria-checked', on ? 'true' : 'false');
      i.tabIndex = i === selected ? 0 : -1;
      if (!text(i) && !i.getAttribute('aria-label')) {
        i.setAttribute('aria-label', i.getAttribute('data-value') || i.getAttribute('title') || '');
      }
    });
    return selected;
  }

  function fixSwatches(root) {
    root.querySelectorAll('[data-swatch-option]').forEach(function (opt) {
      var anyItem = opt.querySelector('[data-swatch-item]');
      if (!anyItem) return;
      var title = opt.querySelector('.t4s-swatch__title');
      var opener = opt.querySelector('button[data-dropdown-open]');
      var wrapper = opt.querySelector('[data-dropdown-wrapper]');
      var list = wrapper ? (wrapper.querySelector('.t4s-dropdown__content') || anyItem.parentElement) : anyItem.parentElement;
      var role = wrapper ? 'option' : 'radio';
      if (once(opt, 'swatch')) {
        if (title) {
          if (!title.id) title.id = 'fb-opt-' + Math.random().toString(36).slice(2, 9);
          // Option titles were coded as H4 headings; keep the look, drop the heading role.
          if (/^H[1-6]$/.test(title.tagName)) title.setAttribute('role', 'presentation');
          list.setAttribute('aria-labelledby', title.id);
        }
        list.setAttribute('role', wrapper ? 'listbox' : 'radiogroup');
        if (opener && wrapper) {
          var cur = opener.querySelector('[data-current-value]');
          if (cur && !cur.id) cur.id = 'fb-cur-' + Math.random().toString(36).slice(2, 9);
          if (title && cur) opener.setAttribute('aria-labelledby', title.id + ' ' + cur.id);
          opener.setAttribute('aria-haspopup', 'listbox');
          var syncExpanded = function () {
            opener.setAttribute('aria-expanded', wrapper.classList.contains('is--opened') ? 'true' : 'false');
          };
          syncExpanded();
          new MutationObserver(syncExpanded).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
          // Keyboard users who open the list land on the current choice.
          opener.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              if (!wrapper.classList.contains('is--opened')) opener.click();
            }
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
              setTimeout(function () {
                if (!wrapper.classList.contains('is--opened')) return;
                var sel = syncOptions(list, role);
                if (sel) sel.focus();
              }, 200);
            }
          });
        }
        list.addEventListener('keydown', function (e) {
          var items = [].slice.call(list.querySelectorAll('[data-swatch-item]')).filter(visible);
          var i = items.indexOf(document.activeElement);
          if (i < 0) return;
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = items[Math.min(i + 1, items.length - 1)];
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = items[Math.max(i - 1, 0)];
          else if (e.key === 'Home') next = items[0];
          else if (e.key === 'End') next = items[items.length - 1];
          else if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            items[i].click();
            if (opener) setTimeout(function () { opener.focus(); }, 60);
            return;
          } else if (e.key === 'Escape' && opener) {
            e.preventDefault();
            if (wrapper && wrapper.classList.contains('is--opened')) opener.click();
            opener.focus();
            return;
          }
          if (!next) return;
          e.preventDefault();
          items[i].tabIndex = -1;
          next.tabIndex = 0;
          next.focus();
          // Inline radio swatches select as focus moves; dropdown options wait for Enter.
          if (role === 'radio') next.click();
        });
        new MutationObserver(function () { syncOptions(list, role); })
          .observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
      syncOptions(list, role);
    });
  }

  /* 3. Main menu dropdowns: announce them and let Escape close them.
        (fb-a11y.css opens them on keyboard focus.) */
  function fixMenus(root) {
    root.querySelectorAll('.t4s-nav__ul > li.has--children').forEach(function (li) {
      var link = li.querySelector(':scope > a');
      if (!link || !once(li, 'menu')) return;
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      function expanded(v) { link.setAttribute('aria-expanded', v ? 'true' : 'false'); }
      li.addEventListener('focusin', function () { if (!li.classList.contains('fb-sub-closed')) expanded(true); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) { li.classList.remove('fb-sub-closed'); expanded(false); }
      });
      li.addEventListener('mouseenter', function () { expanded(true); });
      li.addEventListener('mouseleave', function () { if (!li.contains(document.activeElement)) expanded(false); });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { li.classList.add('fb-sub-closed'); expanded(false); link.focus(); }
      });
    });
  }

  /* 4. Drawers (cart, search, account, filters): treat as dialogs. Move focus in
        when one opens, keep Tab inside while open, and return focus when it closes.
        Only focus is managed; opening, closing and cart behavior are untouched. */
  function focusablesIn(el) {
    return [].slice.call(el.querySelectorAll(FOCUSABLE)).filter(function (n) {
      return visible(n) && !n.closest('[inert]') && getComputedStyle(n).visibility !== 'hidden';
    });
  }

  function fixDrawers(root) {
    root.querySelectorAll('.t4s-drawer').forEach(function (dr) {
      if (!once(dr, 'drawer')) return;
      dr.setAttribute('role', 'dialog');
      dr.setAttribute('aria-modal', 'true');
      if (!dr.getAttribute('aria-label') && !dr.getAttribute('aria-labelledby')) {
        var head = dr.querySelector('.t4s-drawer__header span, .t4s-drawer__header h2, .t4s-drawer__header h3');
        var label = text(head);
        if (!label && dr.id === 't4s-mini_cart') label = 'Shopping cart';
        if (label) dr.setAttribute('aria-label', label);
      }
      var opener = null;
      var isOpen = false;
      new MutationObserver(function () {
        var open = dr.getAttribute('aria-hidden') === 'false';
        if (open && !isOpen) {
          isOpen = true;
          opener = document.activeElement;
          // The drawer slides in, so retry briefly until it can take focus.
          var tries = 0;
          var moveIn = function () {
            if (dr.getAttribute('aria-hidden') !== 'false' || dr.contains(document.activeElement)) return;
            if (document.activeElement && document.activeElement !== opener && document.activeElement !== document.body) return;
            var target = dr.querySelector('input[type="search"], input[name="q"]') ||
              dr.querySelector('[data-drawer-close]') || focusablesIn(dr)[0];
            if (target) target.focus();
            if (!dr.contains(document.activeElement) && ++tries < 8) setTimeout(moveIn, 120);
          };
          setTimeout(moveIn, 80);
        } else if (!open && isOpen) {
          isOpen = false;
          var active = document.activeElement;
          if (opener && document.contains(opener) && (!active || active === document.body || dr.contains(active))) {
            opener.focus();
          }
        }
      }).observe(dr, { attributes: true, attributeFilter: ['aria-hidden'] });
      dr.addEventListener('keydown', function (e) {
        if (dr.getAttribute('aria-hidden') !== 'false') return;
        // Escape closes an open cart panel (note, coupon...) first, then the drawer.
        if (e.key === 'Escape' || e.key === 'Esc') {
          var panel = dr.querySelector('.t4s-mini_cart-tool__content.is--opend');
          var back = panel && panel.querySelector('.t4s-mini_cart-tool__back');
          var closeBtn = dr.querySelector('[data-drawer-close]');
          if (back) back.click(); else if (closeBtn) closeBtn.click();
          return;
        }
        if (e.key !== 'Tab') return;
        var f = focusablesIn(dr);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    });
  }

  /* 4b. Cart drawer tools (order note, gift wrap, shipping estimate, coupon):
         the buttons are plain divs, so make them real keyboard buttons. The
         closed panels sit below the drawer but could still take Tab focus,
         so switch them off (inert) until opened, and return focus on close. */
  function fixCartTools(root) {
    root.querySelectorAll('[data-cart-tool_action]').forEach(function (b) {
      if (!once(b, 'tool')) return;
      b.setAttribute('role', 'button');
      b.setAttribute('tabindex', '0');
      if (!text(b) && b.getAttribute('title')) b.setAttribute('aria-label', b.getAttribute('title'));
      b.querySelectorAll('svg').forEach(function (s) { s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false'); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); b.click(); }
      });
    });
    root.querySelectorAll('.t4s-mini_cart-tool__content').forEach(function (panel) {
      var id = (panel.className.match(/\bis--(note|rates|gift|discount)\b/) || [])[1];
      var sync = function () {
        if (panel.classList.contains('is--opend')) { panel.removeAttribute('inert'); return; }
        var hadFocus = panel.contains(document.activeElement);
        panel.setAttribute('inert', '');
        if (hadFocus && id) {
          var dr = panel.closest('.t4s-drawer') || document;
          var opener = [].slice.call(dr.querySelectorAll('[data-cart-tool_action][data-id="' + id + '"]')).filter(visible)[0] ||
            dr.querySelector('[data-drawer-close]');
          if (opener) opener.focus();
        }
      };
      if (once(panel, 'panel')) new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
      sync();
      var coupon = panel.querySelector('#CartDiscountcode');
      if (coupon && !coupon.getAttribute('aria-label')) coupon.setAttribute('aria-label', text(panel.querySelector('h3')) || 'Discount code');
    });
  }

  /* 4c. Cart items: the photo repeats the product link (one Tab stop is
         enough), and "Remove" should say which product it removes. */
  function fixCartItems(root) {
    root.querySelectorAll('.t4s-mini_cart__item').forEach(function (item) {
      var title = item.querySelector('a.t4s-mini_cart__title');
      var img = item.querySelector('a.t4s-mini_cart__img');
      if (title && img && img.getAttribute('href') === title.getAttribute('href')) {
        img.setAttribute('aria-hidden', 'true');
        img.setAttribute('tabindex', '-1');
      }
      var rm = item.querySelector('a.t4s-mini_cart__remove');
      if (rm && title && text(title) && !rm.querySelector('.fb-sr-only')) {
        var span = document.createElement('span');
        span.className = 'fb-sr-only';
        span.textContent = ' ' + text(title);
        rm.appendChild(span);
      }
    });
  }

  /* 5. Carousels: slides that are off screen (aria-hidden) should not take
        keyboard focus. */
  function syncHiddenSlide(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE + ', [data-fb-ti]').forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-fb-ti')) el.setAttribute('data-fb-ti', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-fb-ti')) {
        var old = el.getAttribute('data-fb-ti');
        if (old === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', old);
        el.removeAttribute('data-fb-ti');
      }
    });
  }

  function fixCarousels(root) {
    root.querySelectorAll('.flickityt4s').forEach(function (car) {
      if (once(car, 'carousel')) {
        new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            if (m.attributeName === 'aria-hidden' && m.target !== car) syncHiddenSlide(m.target);
          });
        }).observe(car, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });
      }
      car.querySelectorAll('[aria-hidden]').forEach(syncHiddenSlide);
    });
  }

  /* 6. Blank overlay links on banners and image tiles: hide duplicates of a
        named link, otherwise name them from the tile's heading or image. */
  function fixOverlayLinks(root) {
    root.querySelectorAll('a.t4s-full-width-link').forEach(function (a) {
      if (!once(a, 'overlay')) return;
      if (text(a) || a.getAttribute('aria-label') || a.getAttribute('aria-hidden') === 'true') return;
      var href = a.getAttribute('href');
      var box = a.parentElement;
      for (var depth = 0; box && depth < 4; depth++, box = box.parentElement) {
        var twin = [].slice.call(box.querySelectorAll('a[href]')).some(function (x) {
          return x !== a && x.getAttribute('href') === href && (text(x) || x.getAttribute('aria-label'));
        });
        if (twin) { a.setAttribute('aria-hidden', 'true'); a.setAttribute('tabindex', '-1'); return; }
        var heading = box.querySelector('h1, h2, h3, h4, h5, h6');
        if (heading && text(heading)) { a.setAttribute('aria-label', text(heading)); return; }
      }
      var img = a.parentElement && a.parentElement.querySelector('img[alt]:not([alt=""])');
      if (img) a.setAttribute('aria-label', img.getAttribute('alt'));
    });
  }

  /* 7a. Header icons (search, account, wishlist, cart) and quantity +/- buttons:
         give icon-only controls a name. */
  function addHiddenText(el, label, always) {
    if (el.getAttribute('aria-label') || el.querySelector('.fb-sr-only')) return;
    if (!always && (el.innerText || '').trim()) return;
    var span = document.createElement('span');
    span.className = 'fb-sr-only';
    span.textContent = label + ' ';
    el.insertBefore(span, el.firstChild);
  }

  function fixIconControls(root) {
    [['.t4s-site-nav__search a, .t4s-site-nav__search button', 'Search'],
     ['.t4s-site-nav__account > a', 'Account'],
     ['.t4s-site-nav__heart a', 'Wishlist'],
     ['.t4s-site-nav__cart > a', 'Cart', true]].forEach(function (pair) {
      root.querySelectorAll(pair[0]).forEach(function (el) { addHiddenText(el, pair[1], pair[2]); });
    });
    // The cart count badge reads as a bare number; label it as items.
    root.querySelectorAll('.t4s-site-nav__cart [data-cart-count]').forEach(function (c) {
      if (once(c, 'count')) c.insertAdjacentHTML('afterend', '<span class="fb-sr-only"> items</span>');
    });
    root.querySelectorAll('button.t4s-quantity-selector.is--minus:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', 'Decrease quantity'); });
    root.querySelectorAll('button.t4s-quantity-selector.is--plus:not([aria-label])').forEach(function (b) { b.setAttribute('aria-label', 'Increase quantity'); });
    root.querySelectorAll('a.t4s-product__review:not([aria-label])').forEach(function (a) {
      if (!(a.innerText || '').trim()) a.setAttribute('aria-label', 'Read reviews');
    });
    root.querySelectorAll('input.t4s-quantity-input:not([aria-label])').forEach(function (i) {
      if (!(i.id && document.querySelector('label[for="' + i.id + '"]'))) i.setAttribute('aria-label', 'Quantity');
    });
  }

  /* 7b. Product cards: the blank link laid over each card duplicates the
         product title link, so hide it from keyboards and screen readers. */
  function fixCardLinks(root) {
    root.querySelectorAll('a.t4s-full-width-link[data-pr-href]').forEach(function (a) {
      a.setAttribute('aria-hidden', 'true');
      a.setAttribute('tabindex', '-1');
    });
  }

  /* 7c. Product page tabs (Details, Ingredients, FAQ): the carousel wraps the
         list items in extra divs, which breaks list semantics. Restore them. */
  function fixTabList(root) {
    root.querySelectorAll('ul.t4s-tabs-ul').forEach(function (ul) {
      ul.setAttribute('role', 'list');
      ul.querySelectorAll('li').forEach(function (li) { li.setAttribute('role', 'listitem'); });
    });
  }

  /* 7. Product photo thumbnail strip: let keyboard users scroll it. */
  function fixThumbStrip(root) {
    root.querySelectorAll('.t4s-carousel__nav-scroller').forEach(function (s) {
      if (!once(s, 'thumbs')) return;
      if (!s.hasAttribute('tabindex')) s.setAttribute('tabindex', '0');
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', 'Product photo thumbnails');
    });
  }

  /* 8. Blog index "Read more" links: add the article title for screen readers. */
  function fixReadMore(root) {
    root.querySelectorAll('a').forEach(function (a) {
      if (!/^read more$/i.test(text(a)) || !once(a, 'readmore')) return;
      var card = a.parentElement;
      for (var depth = 0; card && depth < 5; depth++, card = card.parentElement) {
        var title = card.querySelector('h2, h3, h4, .t4s-post-title, .t4s-article-title');
        if (title && text(title) && !title.contains(a)) {
          var span = document.createElement('span');
          span.className = 'fb-sr-only';
          span.textContent = ' about ' + text(title);
          a.appendChild(span);
          return;
        }
      }
    });
  }

  /* 9. Pages whose visible title is not coded as the main heading (the theme
        section offers no H1 option there): mark that title as the page's
        heading level 1. Only runs when the page has no H1 at all. */
  var PAGE_TITLES = {
    '/pages/about': 'our story',
    '/pages/current-flavor-list': 'current lip balm flavor collection',
    '/pages/rewards-page': 'give $25. get $25.'
  };
  function fixPageTitle() {
    var want = PAGE_TITLES[location.pathname.replace(/\/+$/, '')];
    if (!want || document.querySelector('h1, [role="heading"][aria-level="1"]')) return;
    var main = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    var hits = [].slice.call(main.querySelectorAll('h2, h3, h4, h5, h6, p')).filter(function (el) {
      return text(el).toLowerCase() === want;
    });
    var el = hits[0];
    if (!el) return;
    el.setAttribute('role', 'heading');
    el.setAttribute('aria-level', '1');
  }

  /* 10. Empty headings (the blank contact and wholesale form titles, the
         review carousel's blank title) say nothing, so take them out of the
         heading list. If text arrives later, the heading is restored. */
  function fixEmptyHeadings(root) {
    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (h) {
      var empty = !text(h) && !h.querySelector('img[alt]:not([alt=""]), [aria-label]');
      if (empty && !h.hasAttribute('role')) {
        h.setAttribute('role', 'presentation');
        h.setAttribute('data-fb-empty', '1');
      } else if (!empty && h.getAttribute('data-fb-empty')) {
        h.removeAttribute('role');
        h.removeAttribute('data-fb-empty');
      }
    });
  }

  function run(root) {
    root = root || document;
    [fixPageTitle, fixEmptyHeadings, fixBulkGrid, fixSwatches, fixMenus, fixDrawers, fixCartTools, fixCartItems, fixCarousels, fixIconControls, fixCardLinks, fixTabList, fixOverlayLinks, fixThumbStrip, fixReadMore]
      .forEach(function (fn) { try { fn(root); } catch (err) { if (window.console) console.warn('fb-a11y', fn.name, err); } });
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(document); }, 150);
  }

  function start() {
    run(document);
    // Apps and theme scripts add content after load (order grid, quick view, drawers).
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
